module.exports = __webpack_public_path__ + "img/poster-base.915dd57a.png";